import React from 'react';
import { observer } from 'mobx-react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Parallax } from 'react-parallax';
import authStore from '~/stores/authStore';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import SignUpBtn from '~/components/auth/SignUpBtn';

const useStyles = makeStyles(({ spacing, palette }) =>
    createStyles({
        root: {
            height: 400,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            flexDirection: 'column',
            padding: spacing(10),
            '& > *': {
                margin: spacing(1, 0)
            }
        },
        text: {
            color: palette.primary.contrastText
        }
    })
);

const langLib = {
    en: {
        signUpNow: 'Sign Up Now',
        priceTitle: 'PRICE AND SIGN UP'
    },
    ru: {
        signUpNow: 'Зарегистрироваться',
        priceTitle: 'Цены и Регистрация'
    }
} as const;

const Container = () => {
    const { lang } = authStore;
    const lib = langLib[lang];
    const classes = useStyles();

    return (
        <Parallax blur={2} bgImage="/static/parallax.jpg" bgImageAlt="the cat" strength={1000}>
            <div className={classes.root}>
                <Typography variant="h4" className={classes.text} align="center">
                    {lib['priceTitle']}
                </Typography>
                {lang === 'en' && (
                    <Typography className={classes.text} align="center">
                        Three messengers for the price of one — from $13.99/month per number on orders from 100
                        numbers. <br />
                        WhatsApp + Telegram + MAX with full technical support and 6000+ messages per day.
                    </Typography>
                )}
                {lang === 'ru' && (
                    <Typography className={classes.text} align="center">
                        Три мессенджера по цене одного — от 999 руб./мес. за номер при заказе от 100 номеров.{' '}
                        <br />
                        WhatsApp + Telegram + MAX с технической поддержкой и 6000+ сообщений в день.
                    </Typography>
                )}

                <SignUpBtn>
                    <Button color="secondary" variant="contained" size="large">
                        {lib['signUpNow']}
                    </Button>
                </SignUpBtn>
            </div>
        </Parallax>
    );
};

export default observer(Container);
